import { earnLoopVariantOf } from "MVVM/State/earnLoopExperiment";
import { useIsInternalAccount } from "MVVM/Hooks/useIsInternalAccount";
import { useUser } from "MVVM/Hooks/useUser";

// Internal accounts stay in for QA whatever their bucket, the way the
// unlimited-only paywall does it.
export const useEarnLoop = () => {
  const { allstarUser } = useUser();
  const isInternal = useIsInternalAccount();
  const variant = earnLoopVariantOf(allstarUser?.user);
  return { enabled: isInternal || variant === "treatment", variant };
};
